import React from 'react';
import styled from 'styled-components';
import { Card, Row, Col } from 'antd';
import { COLOR } from 'constants/colors';
import CustomTag from 'components/tag';
import moment from 'moment';
import './index.css';
import { UploadIcon } from 'assets/icons/upload-icon';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getEncryptedUserId } from '__utils/common-utils';
import { useHistory } from "react-router-dom";

interface MandateProps {
    mandatesList: any
}
const GreyText = styled.p`
    font-size: 12px;
    color: ${COLOR.GREY};
    font-weight: 400;

`
const BoldSpan = styled.span<any>`
    font-size: 14px;
    color: ${COLOR.BLACK};
    font-weight: ${(props: any) => props.bold ? 500 : 400};
    padding-left: ${(props: any) => props?.paddingLeft ? props?.paddingLeft : ''}

`
const MandateCards: React.FC<MandateProps> = ({ mandatesList }: MandateProps) => {
    const history = useHistory();
    const { Meta } = Card;
    const getMandateStatus = (status: string) => {
        switch (status) {
            case 'Processing':
                return status;
            case 'New Mandate':
                return 'Pending';
            case 'Approved':
                return status;
            case 'Rejected':
                return status;
        }
    }

    const getVariant = (status: string) => {
        switch (status) {
            case "Processing":
                return 'warning';
            case "New Mandate":
                return 'danger';
            case "Approved":
                return 'success';
            case "Rejected":
                return 'disabled';
        }
    }

    const showPendingMandate = (mandate: any) => {
        Mixpanel.track(getEventName("pendingMandate", "clicked", "mandates"));
        history.push(`/profile/mandates/setup-mandate?flowType=profile&ucc=${getEncryptedUserId()}&mandateId=${window.btoa(mandate.bseMandateId)}&mandateLimit=${window.btoa(mandate.amount)}`)
    }
    
    return <div>
        {
            mandatesList &&
            mandatesList?.map((mandate: any, index: number) => 
            <Card key={index} className='mandateCard'>
                <Meta
                    title={<p className='font18'><span>{mandate.type === "X" ? "Physical ": "E-" }</span>Mandate ID - {mandate.bseMandateId}</p>}
                    description={
                        <div>
                            <CustomTag rounded variant={getVariant(mandate?.status)}>{getMandateStatus(mandate?.status)}</CustomTag>
                            <Row justify='space-between' style={{ width: '100%', marginTop: '16px' }}>
                                <Col xs={18}>
                                    <GreyText>Start Date: <BoldSpan paddingLeft= '12px'>   {moment(mandate.startDate).format('DD MMMM YYYY')}</BoldSpan></GreyText>
                                    <GreyText>End Date: <BoldSpan paddingLeft= '16px'>  {mandate?.endDate ? moment(mandate?.endDate)?.format('DD MMMM YYYY'):'N/A'}</BoldSpan></GreyText>
                                </Col>
                                <Col xs={6} style={{ textAlign: 'right' }}>
                                    <GreyText>Mandate Limit </GreyText>
                                    <BoldSpan bold>&#8377; {mandate.amount.toLocaleString('en-IN')}</BoldSpan>
                                </Col>
                            </Row>
                            { (mandate.status === 'New Mandate' && mandate.type === "X") ? <p className='greenBoldText mt16' onClick={()=> showPendingMandate(mandate)}><UploadIcon enabled={true}/> &nbsp; Upload Mandate Form</p> : null }
                        </div>
                    }
                />
            </Card>)
        }
    </div >;
}

export default MandateCards;